import React, { useCallback, useState } from "react";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import "./index.css";
import { useLocation } from 'react-router-dom';
import { isMobileOrTablet } from "../Utils";

const ContactUs = ({ props }) => {
    const location = useLocation();
    const shouldShowDisclaimers = location.pathname === '/home' || location.pathname === '/'
    // stores current formRef
    const [node, setNode] = useState(null);
    // tracks changes to formRef and stores current with setNode
    const formRef = useCallback((node) => {
        setNode(node);
    }, []);

    const isSwmcDomain = () => {
        const currentUrl = window.location.href;
        return currentUrl.includes('swmc.com');
    };

    return (
        <>
            <div>
                <div className={isMobileOrTablet() ? 'formWrapperMobile' : 'container'}>
                    <div id="ContactUs" className="FormBg">
                        <div className={`formWrapper${node ? "" : " spacer"}`}>
                            {node && (
                                <div className="formHeader mb-2">
                                    <h3 className="formTitle">Contact Us</h3>
                                    <p className="formSubTitle">Get Started In Less Than 60 Seconds...</p>
                                </div>
                            )}
                            <div className="formBody">
                                <BorrowerLeadGenerationTool
                                    ref={formRef}
                                    // mainBtnName="Submit"
                                    leadSource="BUILDER020"
                                    showPropertyStateField={false}
                                    showReactPlayerVideoWindow={false}
                                     domainNameConsent="swmc.com"
                                        language="en"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {shouldShowDisclaimers && (
                    <div className="disclaimers container">
                        <div className="evolution-home-disclaimers">
                            Visit <a href="https://www.evolutionaimortgage.com/disclaimer" target="_blank" rel="noopener noreferrer">evolutionaimortgage.com/disclaimer</a> for terms and limitations of the <a href='https://www.angelai.com/warranty/' target='_blank' rel='noopner noreferrer' className='custom-hyperlink'>AngelAi Warranty</a>.<br />
                            *<a href='https://www.swmc.com/angelai/conversation/59963c8b728167754ee0e3b959184873eadaae91be3cfc00f0e4330f6f684847' target='_blank' rel='noopner noreferrer' className='custom-hyperlink'>Credit Boost</a> through <a href='https://www.swmc.com/angelai/' target='_blank' rel='noopner noreferrer' className='custom-hyperlink'>AngelAi</a> is subject to restrictions and charges (see <a href='https://www.angelai.com/terms-and-conditions/' target='_blank' >angelai.com/terms</a>).
                            <br/>
                            Realtor<sup>®</sup> is a registered trademark of National Association of Realtors<sup>®</sup>.
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ContactUs;
